export default __webpack_public_path__ + "media/images/react_icons/control-chevron-right-8320011dcaa3c01d06723f31fda567f7.svg";